// extracted by mini-css-extract-plugin
export default {"image":"x3-z","loaded":"y3-z"};